// Helpful? under the platform agent's finished answers and cards (D10). Wording from the Amigo design's copy sheet
// (Helpful?).
export default {
  question: 'Nyttigt?',
  helpful: 'Nyttigt',
  not_helpful: 'Ikke nyttigt',
  thanks: 'Tak, det er noteret.',
};
